import { configureStore } from '@reduxjs/toolkit'
import OrganizationSlice from './slices/OrganizationSlices'
import OrganizationLocationSlice from './slices/OrganizationLocationSlices'
import UserSlice from './slices/UserSlices'
import RoleSlice from './slices/RoleSlices'
import GroupSlice from './slices/GroupSlices'
import SystemCodeSlice from './slices/SystemCodeSlices'
import WorkflowSlice from './slices/WorkflowSlices'
import CustomSettingSlice from './slices/CustomSettingSlices'
import ModuleSlice from './slices/ModuleSlice'
import PermissionSlice from './slices/PermissionSlice'
import authSlice from './slices/AuthSlices'
import CouponSlice from './slices/CouponSlice'
import OfferSlice from './slices/OfferSlice'
import GiftGallerySlice from './slices/GiftGallerySlice'
import ClientSlice from './slices/ClientSlice'
import ClientWalletSlice from './slices/ClientWalletSlice'
import TransactionSlice from './slices/TransactionSlice'
import CatalogueSlice from './slices/CatalogueSlice'
import DashboardSlice from './slices/DashboardSlice'
import DealerPriceListSlice from './slices/DealerPriceListSlice'
import DealerSchemeSlice from './slices/DealerSchemeSlice'
import commonSlice from './slices/CommonSlices'
import ProductSlice from './slices/ProductSlice'
import ReportSlice from './slices/ReportSlice'

// Configure the store
export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    common: commonSlice.reducer,
    organization: OrganizationSlice.reducer,
    organizationLocation: OrganizationLocationSlice.reducer,
    user: UserSlice.reducer,
    role: RoleSlice.reducer,
    group: GroupSlice.reducer,
    systemCode: SystemCodeSlice.reducer,
    workflow: WorkflowSlice.reducer,
    customSetting: CustomSettingSlice.reducer,
    module: ModuleSlice.reducer,
    permission: PermissionSlice.reducer,
    coupon: CouponSlice.reducer,
    offer: OfferSlice.reducer,
    catalogue: CatalogueSlice.reducer,
    dashboard: DashboardSlice.reducer,
    giftGallery: GiftGallerySlice.reducer,
    client: ClientSlice.reducer,
    clientWallet: ClientWalletSlice.reducer,
    transaction: TransactionSlice.reducer,
    dealerPriceList: DealerPriceListSlice.reducer,
    dealerScheme: DealerSchemeSlice.reducer,
    product: ProductSlice.reducer,
    report: ReportSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disables serialization checks (for non-serializable data)
    }),
})

// Define RootState type
export type RootState = ReturnType<typeof store.getState>

// Define AppDispatch type
export type AppDispatch = typeof store.dispatch
